import React, { useEffect } from 'react'
import { Html } from '@react-three/drei'
import useApp from './hook/useApp'

export default function Annotation({ children, ...props }) {
  const { _clickMarker, _clickOpen } = useApp()

  const clickMarker = (w) => {
    _clickMarker(w)
    _clickOpen(w)
  }

  return (
    <Html {...props} occlude="blending">
      <div
        style={{ visibility: props.visibility }}
        className="c-annotation"
        onClick={() => {
          clickMarker(props.marker)
        }}>
        {children}
      </div>
    </Html>
  )
}
